import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EmopEditorData } from '../../common/EmopEditorData';
import * as hljs from "highlight.js";
import { EmopUtilsService } from '../../../app/services/emop-utils.service';

@Component({
  selector: 'emop-editor',
  templateUrl: './emop-editor.component.html',
  styleUrls: ['./emop-editor.component.scss']
})
export class EmopEditorComponent implements OnInit {
  @Input() data: EmopEditorData;
  @Input() theme: 'light' = 'light';
  private lines: number = 1; // 总行数
  initContent = '';
  constructor(
    private emop: EmopUtilsService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.init();
    }, 0);
  }
  /**
   * 对content进行处理
   */
  init() {
    if (!this.data?.content) return;
    this.initContent = this.data.content;
    this.scss(this.data);
    this.initContent = hljs.highlight(this.initContent, { language: this.data.language }).value;
    this.data.language === 'json' && this.json(this.data);

    // 处理序号
    this.initContent = `<span class="index">${this.lines++}</span>` + this.initContent;
    while (/\n/.test(this.initContent)) {
      this.initContent = this.initContent.replace(/\n/, `<br/><span class="index">${this.lines++}</span>`);
    }
    this.lines = 1;
  }
  /**
   * 针对scss进行处理
   * @param data 
   */
  scss(data: EmopEditorData) {
    this.initContent = this.initContent.replace(/::ng-deep/g, '<span class="ng-deep">::ng-deep</span>');
  }
  /**
   * 针对json进行处理
   * @param data 
   */
  json(data: EmopEditorData) {
    this.initContent = this.initContent.replace(/\[/g, '[\n');
    this.initContent = this.initContent.replace(/\[\n{/g, '[{');
    this.initContent = this.initContent.replace(/\{/g, '{\n');
    this.initContent = this.initContent.replace(/\,/g, ',\n');
  }
  /**
   * 复制文本
   */
  copy() {
    if (this.emop.copy(this.data.content)) {
      this.emop.message('success', '复制成功');
    }
  }
}
